import { Link } from 'react-router-dom';
import { ArrowUpRight } from 'lucide-react';
import { ScrollLines, Reveal, Eyebrow } from '@/components/Reveal';

export default function CtaBand() {
  return (
    <section className="border-y border-white/10 bg-bark/40">
      <div className="mx-auto max-w-7xl px-6 py-24 md:px-12 md:py-32">
        <Reveal>
          <Eyebrow>Start the trade</Eyebrow>
        </Reveal>
        <ScrollLines
          className="mt-6 block"
          lineClassName="font-serif text-5xl leading-[1.02] text-bone sm:text-6xl lg:text-7xl"
          lines={['Let’s price your', 'next container.']}
        />
        <Reveal delay={0.15} className="mt-8 flex flex-col gap-5 sm:flex-row sm:items-center">
          <p className="max-w-md text-sm leading-relaxed text-dune">
            Send the spec — spice, grade, volume, destination. The trade desk replies with an
            indicative quote within one business day.
          </p>
          <Link
            to="/contact"
            data-testid="cta-band-button"
            className="inline-flex items-center justify-center gap-2 rounded-full bg-turmeric px-7 py-3.5 text-[12px] font-semibold uppercase tracking-[0.18em] text-night transition-all duration-300 hover:scale-[1.03] hover:bg-bone"
          >
            Request a Quote
            <ArrowUpRight className="h-4 w-4" strokeWidth={2} />
          </Link>
        </Reveal>
      </div>
    </section>
  );
}
